import React from "react"

const Header = () => (
  <nav class="w-full flex items-center justify-center bg-primary p-4">
    <img src={"logo_sokuyaku_wh.svg"}  class="header-logo" alt={"top_image"}/>
  </nav>
)

export default Header
